// extracted by mini-css-extract-plugin
export default {"sobreNos":"Sobre_sobreNos__16CTi","sobreNos__texto":"Sobre_sobreNos__texto__H6a2a","imagens":"Sobre_imagens__akFo4","imagens__imagem":"Sobre_imagens__imagem__k0Z5t"};